
export enum UserActionTypes {
    UPDATE_USER = '@@/user/update_user',
    LOGOUT_USER = '@@/user/logout_user',

}